// Technical settings on the general briefing.
//
// `briefings.camera_settings` is stored as jsonb in the shape
// { text: string } (the producer edits a single free-text field). The
// crew app, the producer editor and the read-only portal view all need
// to read that same `text` out again. This helper owns that read once,
// so the three sides don't drift — a past drift is exactly what hid the
// camera settings in the portal's read-only briefing view, where a
// generic key-loop skipped the `text` key it should have shown.
//
// Defensive (not a blind cast): the value is read on crew devices and
// the producer portal, so a legacy plain-string row or a malformed
// object degrades to "" instead of throwing.

export function cameraSettingsText(value: unknown): string {
  if (typeof value === "string") return value;
  if (value && typeof value === "object" && !Array.isArray(value)) {
    const text = (value as Record<string, unknown>).text;
    if (typeof text === "string") return text;
  }
  return "";
}
